<template>
  <div id="maintenance">
    <h1>{{ $t("onboard.maintenance.header") }}</h1>
    <p>{{ $t('onboard.maintenance.text') }}</p>
  </div>
</template>

<script>
export default {
  name: 'Maintenance'
}
</script>
